// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"e8f24033","127":"e221e93a","233":"5dc57e7e","243":"8b4ad9ca","269":"deeadea6","373":"d2140bac","461":"89fef11d","646":"8b332670","736":"908b6a83","767":"16286210","880":"1e02f090"}[chunkId] + ".chunk.css";
};